/**
 * Default export pour l'auto-discovery `apps/web/src/routes/modules.ts`.
 *
 * Onglet « Logistique » (icône lucide `truck`, spec §7), réservé aux admins
 * (`apps/web/src/lib/acces.ts` `ECRANS_RESERVES_ADMIN` : 'logistique' ;
 * l'API refuse 403 de son côté). Quatre routes : la liste des factures
 * (onglet visible), le détail d'une facture, le tableau de bord et les
 * réceptions (cachées de
 * la barre, atteintes depuis les onglets internes du module — même patron que
 * `herbo-kpi-entrepot/web/route.tsx`).
 */
import { lazy, Suspense, type ReactNode } from 'react';
import type { ModuleRoute } from '@herbo/module-route';

const Factures = lazy(() => import('./pages/Factures'));
const DetailFacture = lazy(() => import('./pages/DetailFacture'));
const TableauDeBord = lazy(() => import('./pages/TableauDeBord'));
const Receptions = lazy(() => import('./pages/Receptions'));

function avecSuspense(node: ReactNode, texte: string): ReactNode {
  return <Suspense fallback={<div className="px-6 py-8 text-sm text-slate-500">{texte}</div>}>{node}</Suspense>;
}

const liste: ModuleRoute = {
  path: 'logistique',
  label: 'Logistique',
  icon: 'truck',
  element: avecSuspense(<Factures />, 'Chargement des factures du 3PL…'),
};

const detail: ModuleRoute = {
  path: 'logistique/factures/:id',
  label: 'Logistique',
  icon: 'truck',
  hidden: true,
  element: avecSuspense(<DetailFacture />, 'Chargement de la facture…'),
};

const tableau: ModuleRoute = {
  path: 'logistique/tableau-de-bord',
  label: 'Logistique',
  icon: 'truck',
  hidden: true,
  element: avecSuspense(<TableauDeBord />, 'Chargement du tableau de bord…'),
};

/** Lot 2 : coût des réceptions fournisseurs par commande (spec lot 2 §2). */
const receptions: ModuleRoute = {
  path: 'logistique/receptions',
  label: 'Logistique',
  icon: 'truck',
  hidden: true,
  element: avecSuspense(<Receptions />, 'Chargement des réceptions…'),
};

export default [liste, detail, tableau, receptions];
